import { Grid } from '@cmg/design-system';
import type { FC, PropsWithChildren } from 'react';

export const FormFieldLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Grid item xs={12} paddingY={1}>
      {children}
    </Grid>
  );
};
